import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";
import { AuthguardService } from './authguard.service';

@Injectable({
  providedIn: 'root'
})
export class AuthCandidateGuard implements CanActivate {
  constructor(
    private auth: AuthguardService,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentUserinvigi = this.auth.gettoken_candidate();
    if (currentUserinvigi) {
      return true;
    }

    this.router.navigate(['/candidate']);
    return false;

    return true;
  }

}
